import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericPipePipe } from './pipes/generic-pipe/generic-pipe.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [GenericPipePipe],
  exports: [GenericPipePipe],
})
export class CoreFeaturesGenericPipeModule {}
